import React from 'react';
// import H from './Headings';
import StarRating from './StarRating';
import TagCloud from './TagCloud';
import CallToAction from './CallToAction';
import ModuleCard from './ModuleCard';
import ModulesRSE from './ModulesRSE';

/* eslint-disable */
export default {
	// h1: (props) => <H as="h1" {...props} />,
	// h2: (props) => <H as="h2" {...props} />,
	// h3: (props) => <H as="h3" {...props} />,
	// h4: (props) => <H as="h4" {...props} />,
	// h5: (props) => <H as="h5" {...props} />,
	// h6: (props) => <H as="h6" {...props} />,
	StarRating: (props) => <StarRating {...props} />,
	TagCloud: (props) => <TagCloud {...props} />,
	CallToAction: (props) => <CallToAction {...props} />,
	ModuleCard: (props) => <ModuleCard {...props} />,
	ModulesRSE: (props) => <ModulesRSE {...props} />,
};
